import { render, staticRenderFns } from "./AppConfirm.vue?vue&type=template&id=25d94a70&scoped=true&"
import script from "./AppConfirm.vue?vue&type=script&lang=js&"
export * from "./AppConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d94a70",
  null
  
)

export default component.exports